export const SHELL_COURSE_UUID = "dd2f9319-bce9-4e43-8b45-12685ce6c6e2";
export const SHELL_COURSE_PATH = "/courses/shell/shell";
export const SHELL_USER = "you";
export const SHELL_HOME_DIR = `/home/${SHELL_USER}`;
